import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifier = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 14,
	viewBox: "0 0 14 14",
	width: 14,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m9.95087 9.41985 3.15773 3.15775c.1467.1466.1467.3844 0 .5311-.1466.1466-.3844.1466-.5311 0l-3.15773-3.15776z",
			stroke: "#414141",
			strokeWidth: .885
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m5.93083 11.8615c-3.27551 0-5.93083-2.65529-5.93083-5.93075s2.65532-5.93075 5.93083-5.93075 5.93087 2.65529 5.93087 5.93075-2.65536 5.93075-5.93087 5.93075z",
			fill: "#414141"
		}),
		/* @__PURE__ */ _jsx("path", {
			clipRule: "evenodd",
			d: "m5.93081 10.6341c2.59782 0 4.70379-2.10594 4.70379-4.70372s-2.10597-4.7037-4.70379-4.7037c-2.59781 0-4.70376 2.10592-4.70376 4.7037s2.10595 4.70372 4.70376 4.70372z",
			fill: "#fff",
			fillRule: "evenodd"
		})
	]
});
export { SvgMagnifier as ReactComponent };
